import proxybase from './proxybase';

class WeddingRequestService {
  getInitialInfo(body) {
    return proxybase
      .post(`/weddingRequest/WeddingStepLogIn`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  submitWeddingRequest(body) {
    return proxybase
      .post(`/weddingRequest/submitWeddingRequest`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getAllWeddingRequests(body) {
    return proxybase
      .post(`/weddingRequest/getAllWeddingRequests`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getAllWeddingFacilitators(body) {
    return proxybase
      .post(`/weddingRequest/getAllWeddingFacilitators`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  createWeddingFacilitator(body) {
    return proxybase
      .post(`/weddingRequest/createWeddingFacilitator`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  SDeleteWeddingFacilitator(body) {
    return proxybase
      .post(`/weddingRequest/SDeleteWeddingFacilitator`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  WeddingEditRequest(body) {
    return proxybase
      .post(`/weddingRequest/WeddingEditRequest`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  getAllWeddingRequestsByGroup(body) {
    return proxybase
      .post(`/weddingRequest/getAllWeddingRequestsByGroup`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  WeddingRequestsLeaderChecks(body) {
    return proxybase
      .post(`/weddingRequest/WeddingRequestsLeaderChecks`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  WeddingRequestsFacilitatorLog(body) {
    return proxybase
      .post(`/weddingRequest/WeddingRequestsFacilitatorLog`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
  WeddingFacilitatorEditRequest(body) {
    return proxybase
      .post(`/weddingRequest/WeddingFacilitatorEditRequest`, body)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
const weddingRequestServiceInstance = new WeddingRequestService();
export default weddingRequestServiceInstance;
